<template>
  <v-container
    class="pa-0"
    fluid
  >
    <v-combobox
      ref="combo"
      v-model="model"
      :filter="filter"
      :hide-no-data="!search"
      :items="items"
      :search-input.sync="search"
      :label="(label ? $t(label) : $t('status'))"
      :flat="(!hideconfig? true : false)"
      :clearable="(!hideconfig? false : true)"
      :outlined="(!hideconfig? false : true)"
      :solo="(!hideconfig? true : false)"
      :multiple="(multiple ? multiple : false)"
      :menu-props="{maxHeight: 200}"
      :dense="!offDens"
      height="32"
      item-value="id"
      item-text="name"
      small-chips
      hide-details
      :background-color="(!hideconfig ? '#e5e5e5' : null)"
      @blur="$emit('blur', model)"
    >
      <template
        v-slot:append
      >
        <v-tooltip
          bottom
        >
          <template
            v-slot:activator="{ on, attrs }"
          >
            <v-btn
              v-bind="attrs"
              small
              icon
              color="grey"
              v-on="on"
              style="top:-2px"
              @click="setting = true"
            >
              <v-icon>mdi-cog-outline</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('edit-status') }}</span>
        </v-tooltip>
      </template>
      <template v-slot:no-data>
        <v-list-item>
          <span class="subheading">{{ $t('not-status') }}</span>
          <!--          <v-chip-->
          <!--            :color="`${colors[nonce - 1]} lighten-3`"-->
          <!--            label-->
          <!--            small-->
          <!--          >-->
          <!--            {{ search }}-->
          <!--          </v-chip>-->
        </v-list-item>
      </template>
      <template v-slot:selection="{attrs, item, parent, selected }">
        <v-chip
          v-if="item === Object(item)"
          v-bind="attrs"
          :color="item.color"
          :input-value="selected"
          label
          small
          style="cursor: pointer"
          class="px-1"
          :class="(multiple ? 'my-1' : false)"
        >
          <span class="px-2 white--text">
            {{ item.name }}
          </span>
        </v-chip>
      </template>
      <template v-slot:item="{ index, item }">
        <v-chip
          :color="item.color"
          dark
          label
          small
        >
          {{ item.name }}
        </v-chip>
        <v-spacer />
        <v-btn
          color="grey"
          dark
          x-small
          text
        >
          {{ item.template.name }}
        </v-btn>
      </template>
    </v-combobox>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="dialog"
      width="300"
    >
      <v-card
        v-if="editing"
        class="pl-4"
      >
        <v-col>
          <v-color-picker
            v-model="editingColor"
            dot-size="25"
            hide-canvas
            hide-inputs
            hide-mode-switch
            hide-sliders
            mode="hexa"
            show-swatches
            swatches-max-height="132"
          />
        </v-col>
        <v-col
          cols="12"
          class="pr-7"
        >
          <aicomplete
            v-model="template"
            title="list"
            type="statusTemplate"
            :val="template"
            :outlined="false"
          />
        </v-col>
        <v-col
          class="pr-7"
        >
          <v-text-field
            v-model="editingText"
            dense
            flat
            filled
            autofocus
            @keydown="keydown($event)"
          />
        </v-col>
        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="submit"
          >
            {{ $t('edit') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="stop"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            color="grey darken-2"
            @click="stop = false"
          >
            <v-icon large>
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-status') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="stop = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="setting"
      width="70%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn
            icon
            @click="setting = false"
          >
            <v-icon
              class="close-hover"
              color="grey darken-2"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('edit-status') }}
          </p>
        </v-col>
        <v-col>
          <v-col
            cols="12"
          >
            <aicomplete
              v-model="templateFilter"
              title="list"
              type="statusTemplate"
              :outlined="false"
              :new-btn="true"
              :set-init="true"
              :backround-color="'#e5e5e5'"
              :solo="true"
              :flat="true"
            />
          </v-col>
          <v-list>
            <v-list-item
              v-for="(item, index) in items"
              :key="index"
            >
              <v-list-item-content class="pa-0 d-inline d-flex flex-row">
                <v-col>
                  <v-chip
                    :color="item.color"
                    dark
                    label
                    small
                  >
                    {{ item.name }}
                  </v-chip>
                  <v-chip
                    class="mx-1"
                    color="#babfc7"
                    dark
                    outlined
                    label
                    x-small
                  >
                    {{ item.state }}
                  </v-chip>
                </v-col>
                <v-col class="d-flex flex-row-reverse">
                  <v-btn
                    v-if="item.state === 'active'"
                    small
                    icon
                    @click.stop.prevent="openStop(item)"
                  >
                    <v-icon color="pink">
                      mdi-delete-outline
                    </v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    small
                    @click.stop.prevent="edit(index, item)"
                  >
                    <v-icon color="grey">
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </v-col>
                <v-divider />
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
        <v-col
          cols="12"
          md="6"
          class="mt-3 pr-4 d-flex mr-4"
        >
          <v-text-field
            v-model="newStatus"
            :placeholder="$t('new-status-placeholder')"
            outlined
            dense
            clearable
            class="me-2"
            @keydown="keydownAdd"
          />
          <v-btn
            height="30"
            color="primary"
            small
            @click="add"
          >
            {{ $t('add-status') }}
          </v-btn>
        </v-col>
        <v-col class="ma-0">
          <p class="mx-auto pr-7 my-0 grey--text text--lighten-1">
            {{ $t('you-can-delete-active-status') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="trackDialog"
      width="70%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn
            icon
            color="grey darken-2"
            @click="trackDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col class="px-8">
          <statustrack
            :id="id"
            :type="type"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  import aicomplete from '../AIcomplete/index'
  export default {
    components: {
      aicomplete,
      Statustrack: () => import('../../../pages/General/statusTrack'),
    },
    props: ['type', 'input', 'id', 'hideconfig', 'value', 'multiple', 'config', 'templateProp', 'offDens', 'label'],
    data: () => ({
      activator: null,
      trackDialog: false,
      tracks: null,
      templateFilter: null,
      template: null,
      attach: null,
      deleteItem: null,
      setting: false,
      stop: false,
      formHasErrors: false,
      dialog: false,
      colors: ['green', 'red', 'blue', 'purple', 'pink', 'orange', 'deep-purple', 'teal', 'cyan', 'indigo', 'orange', 'amber', 'brown', 'deep-orange', 'grey', 'blue-grey'],
      editing: null,
      editingText: null,
      setInit: null,
      oldText: null,
      newStatus: null,
      editingColor: null,
      editingIndex: -1,
      errorMessages: '',
      items: [],
      nonce: 1,
      menu: false,
      model: null,
      x: 0,
      search: null,
      y: 0,
    }),
    watch: {
      templateFilter () {
        if (this.templateFilter) {
          this.getItems()
        }
      },
      templateProp () {
        if (this.templateProp) {
          this.templateFilter = this.templateProp
          this.model = null
          this.getItems()
        }
      },
      value () {
        if (this.value) {
          this.model = this.value
        }
      },
      model (val, prev) {
        this.$emit('input', this.model)
      },
    },
    mounted () {
      this.getItems()
      if (this.value) {
        this.model = this.value
      }
      if (this.input) {
        this.model = this.input
      }
    },
    methods: {
      setData (id) {
        if (this.items.length > 0) {
          this.setInit = id
          this.getItems()
        } else {
          var index = this.items.findIndex(x => x.id === id)
          this.model = this.items[index]
        }
      },
      getLastStatus (id, type) {
        var app = this
        app.isLoading = true
        app.$axios.get(this.$endpoint + 'status/show', {
          params: {
            lastStatusId: id,
            type: type,
          },
        })
          .then(res => {
            var index = app.items.findIndex(x => x.id === res.data)
            app.model = app.items[index]
          })
          .catch(err => {
            var error = err.response
            if (error.status === 500) {}
            if (error.status === 401) {
              app.$router.push({ name: 'logout' })
            }
          })
          .finally(() => (app.isLoading = false))
      },
      add () {
        var v = {
          name: this.newStatus,
          color: 'grey',
          type: this.type,
          state: 'active',
          id: null,
        }
        this.newStatus = null
        this.create(v)
        this.nonce++
      },
      create (item) {
        var app = this
        app.isLoading = true
        app.$axios.post(this.$endpoint + 'status', {
          name: item.name,
          color: item.color,
          type: app.type,
          template_id: (app.templateFilter ? app.templateFilter.id : null),
        })
          .then(res => {
            app.items.push(res.data.data)
          })
          .catch(err => {
            var error = err.response
            if (error.status === 500) {}
            if (error.status === 401) {
              app.$router.push({ name: 'logout' })
            }
          })
          .finally(() => (app.isLoading = false))
      },
      getItems () {
        var app = this
        app.isLoading = true
        app.$axios.get(this.$endpoint + 'status/show', {
          params: {
            template_id: (app.templateFilter ? app.templateFilter.id : null),
          },
        })
          .then(res => {
            app.items = res.data.data
            if (app.id) {
              // app.getLastStatus()
            } else {
              if (!app.hideconfig) {
                var index = app.items.findIndex(x => x.state === 'active')
                app.model = app.items[index]
              }
            }
          })
          .catch(err => {
            var error = err.response
            if (error.status === 500) {}
            if (error.status === 401) {
              app.$router.push({ name: 'logout' })
            }
          })
          .finally(() => (app.isLoading = false))
      },
      keydownAdd: function (event) {
        switch (event.keyCode) {
          case 13:
            this.add()
            break
        }
      },
      keydown: function (event) {
        switch (event.keyCode) {
          case 13:
            this.submit()
            break
        }
      },
      submit () {
        var index = this.items.findIndex(x => x.name === this.oldText)
        this.items[index].name = this.editingText
        this.items[index].color = this.editingColor
        this.dialog = false
        var app = this
        app.$axios.get(this.$endpoint + 'status/' + this.items[index].id + '/edit', {
          params: {
            name: this.editingText,
            template_id: (this.template ? this.template.id : null),
            color: this.editingColor,
          },
        })
          .then(res => {
          })
          .catch(err => {
            var error = err.response
            if (error.status === 500) {}
            if (error.status === 401) {
              app.$router.push({ name: 'logout' })
            }
          })
          .finally(() => (app.isLoading = false))
      },
      edit (index, item) {
        this.editing = item
        this.editingIndex = index
        this.editingText = item.name
        this.template = item.template
        this.editingColor = item.color
        this.oldText = item.name
        this.dialog = true
      },
      openStop (item) {
        this.deleteItem = item
        this.stop = true
      },
      remove () {
        var index = this.items.findIndex(x => x.id === this.deleteItem.id)
        this.items.splice(index, 1)
        this.stop = false
        var app = this
        app.$axios.delete(this.$endpoint + 'status/' + this.deleteItem.id)
          .then(res => {
          })
          .catch(err => {
            var error = err.response
            if (error.status === 500) {}
            if (error.status === 401) {
              app.$router.push({ name: 'logout' })
            }
          })
          .finally(() => (app.isLoading = false))
      },
      filter (item, queryText, itemText) {
        // if (item.header) return false

        const hasValue = val => val != null ? val : ''

        const text = hasValue(itemText)
        const query = hasValue(queryText)

        return text.toString()
          .toLowerCase()
          .indexOf(query.toString().toLowerCase()) > -1
      },
    },
  }
</script>
